/**
 * 地圖客戶端策略（與後端 client=compact 對齊）
 * compact：觸控為主或窄屏 → 附近、限縮放
 * desktop：滑鼠寬屏 → 全台總覽
 */
export function isCompactMapClient() {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
    return window.matchMedia('(pointer: coarse)').matches
        || window.matchMedia('(max-width: 768px)').matches;
}

export function mapClientQuery() {
    return isCompactMapClient() ? 'compact' : 'desktop';
}

export function appendMapClientQuery(params) {
    const q = params instanceof URLSearchParams ? params : new URLSearchParams(params || {});
    q.set('client', mapClientQuery());
    return q;
}

/** 與後端 pinnedRouteQueryZoom 對齊：手機高縮放不逼 by-ids 走 full 幾何檔 */
export function pinnedRouteQueryZoom(mapZoom) {
    const z = Number(mapZoom);
    if (!Number.isFinite(z)) return mapZoom;
    if (isCompactMapClient() && z >= 16) return 15;
    return z;
}
